<script lang="ts">
import { useDesignStore } from '@/stores/designStore.ts'
import { useMartialPerksStore } from '@/stores/martialPerksStore.ts'
import { useSpellStore } from '@/stores/spellsStore.ts'
import { computed, ref } from 'vue'
import SearchableDropdown from './SearchableDropdown.vue'
import FilterByActionCost from './Character/Overview/FilterByActionCost.vue'
import SpellsTable from './Character/Build/Spell/SpellsTable.vue'

export default {
  emits: ['ability'],
  setup(props, context) {
    const designStore = useDesignStore()
    const spellStore = useSpellStore()
    const martialPerksStore = useMartialPerksStore()
    const showMessage = ref(true)
    const value = ''
    const actionCost = ref('Any')
    const spells = computed(() => {
      const val = Object.values(spellStore.manualSpellgroups).reduce(
        (acc: any[], spellgroup: any) => acc.concat(Object.values(spellgroup.spells)),
        []
      )
      return val
    })
    const perks = computed(() => {
      let ret: Array<any> = []
      ret = Object.values(martialPerksStore.manualMartialPerks)
      return ret
    })
    function getMedallion(group: string) {
      switch (group) {
        case 'Offensive Perks':
          return 'gi-swords-power'
        case 'Defensive Perks':
          return 'gi-heavy-helm'
        case 'Utility Perks':
          return 'gi-gear-hammer'
        case 'Supportive Perks':
          return 'gi-heart-shield'
      }
    }
    function selectAbility(ability: string) {
      const parts = ability.split(': ')
      const name = parts[parts.length - 1].split('-')[1]
      const group = parts[0]
      if (group === 'Perk') {
        context.emit('ability', {
          ...martialPerksStore.manualMartialPerks[name],
          groupIcon: getMedallion(martialPerksStore.manualMartialPerks[name].perkGroup)
        })
      } else if (group === 'Spellgroup') {
        context.emit('ability', {
          ...spellStore.manualSpellgroups[parts[1]].spells[name],
          groupIcon: spellStore.manualSpellgroups[parts[1]].groupIcon
        })
      } else {
        alert('Please Select Ability From Dropdown')
      }
    }
    const filteredAbiltiies = computed(() => {
      let spellArr = spells.value
      let perksArr = perks.value
      if (actionCost.value != 'Any') {
        spellArr = spellArr.filter((val: any) => val.actionCost.includes(actionCost.value))
        perksArr = perksArr.filter((val: any) => val.actionCost.includes(actionCost.value))
      }

      return perksArr
        .map((perk: any) => 'Perk: ' + perk.perkGroup + ': ' + perk.rank + '-' + perk.name)
        .concat(
          spellArr.map(
            (spell: any) => 'Spellgroup: ' + spell.spellgroup + ': ' + spell.rank + '-' + spell.name
          )
        )
        .sort()
    })
    return {
      designStore,
      value,
      props,
      filteredAbiltiies,
      selectAbility,
      showMessage,
      actionCost
    }
  },
  components: {
    SearchableDropdown,
    FilterByActionCost
  }
}
</script>
<template>
  <div style="display: flex; flex-direction: column; width: 100%">
    <FilterByActionCost
      :alt-visual="true"
      @actionCost="
        (val) => {
          actionCost = val.name
        }
      "
    ></FilterByActionCost>
    <div style="display: flex; flex-direction: row; width: 100%" @click="showMessage = false">
      <div
        style="
          position: absolute;
          z-index: 10;
          margin-top: 0.5rem;
          margin-left: 0.5rem;
          pointer-events: none;
        "
        :style="{ color: designStore.inputText }"
        v-if="showMessage"
      >
        Search for Ability...
      </div>
      <SearchableDropdown
        :options="filteredAbiltiies"
        @select="(selection) => selectAbility(selection)"
        borders="left"
      ></SearchableDropdown>
    </div>
  </div>
</template>
<style>
.menu {
  width: 100%;
  position: absolute;
  z-index: 10;
  overflow-y: scroll;
  max-height: 12.75rem;
  padding: 0.5rem;
  border: 1px solid;
}
.menuOption {
  width: inherit;
  cursor: pointer;
}
.menuOption:hover {
  --hover-bg: blue;
  --hover-text: white cursor: pointer;
  background: var(--hover-bg);
  color: var(--hover-text);
}
</style>
